import { useMemo } from "react";
import { formatDate } from "utils/date";
import dayjs from "config/dayjs";
import { DEFAULT_TIME_FORMAT } from "utils/date";
import { PickerMode, PICKER_MODE } from "../constants";

/**
 * Hook to format value to display text
 */
export const useValueFormatter = (
  mode: PickerMode,
  value: Date | string | null | undefined,
  dayJsFormat: string
) => {
  return useMemo(() => {
    if (!value) return "";

    if (mode === PICKER_MODE.DATE) {
      return formatDate(value, dayJsFormat);
    } else {
      return dayjs(value, DEFAULT_TIME_FORMAT).format(dayJsFormat);
    }
  }, [mode, value, dayJsFormat]);
};
